<script>
import BaseButton from '../_base-button.vue'
import BaseIcon from '../_base-icon.vue'

export default {
    name: 'InAppBrowserModal',

    components: {
        BaseButton,
        BaseIcon,
    },

    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            url: this.data.url || window.location.href,
        }
    },

    methods: {
        close() {
            this.$emit('close')
        },
        openExternal() {
            window.location.href = `x-web-search://?${this.url}`
            window.open(this.url, '_blank')
            this.close()
        },
    },
}
</script>

<template>
    <div :class="$style.modal">
        <button
            :class="$style.closeButton"
            aria-label="Close modal"
            @click="close"
        >
            <BaseIcon
                :class="$style.closeIcon"
                name="close-outline"
            />
        </button>

        <div :class="$style.content">
            <h2 :class="$style.headline">
                Enjoy the best FRISKY experience
            </h2>
            <p :class="$style.description">
                For the best experience, please open this link in your device's default browser.
            </p>

            <div :class="$style.actions">
                <BaseButton
                    :class="$style.primaryButton"
                    size="large"
                    button-type="primaryFlat"
                    @click="openExternal"
                >
                    Open Link
                </BaseButton>
            </div>

            <div :class="$style.instructions">
                <p><strong>If the link doesn't open:</strong></p>
                <ol :class="$style.instructionsList">
                    <li>
                        Tap <span :class="$style.optionsButton">&#8230;</span> (options menu)
                    </li>
                    <li>
                        Select <strong>Open in External Browser</strong>
                    </li>
                </ol>
            </div>
        </div>
    </div>
</template>

<style module lang="scss">
@use '@design' as *;

.modal {
    position: relative;
    width: 90vw;
    max-width: 710px;
    padding: $s-h 64px 48px;
    background: #27292D;
    border: none;
    border-radius: 12px;
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.95);

    @include mobileOnly {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: calc(100vw - $s-xxl);
        max-width: none;
        height: auto;
        padding: $s-xxl 30px 36px;
        margin: $s-l;
        border-radius: $s-m;
    }
}

.closeButton {
    position: absolute;
    top: $s-l;
    right: $s-l;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: $s-xxs;
    color: rgba(255, 255, 255, 0.4);
    cursor: pointer;
    background: transparent;
    border: none;
    border-radius: 50%;
    transition: all 0.2s ease;

    .closeIcon {
        width: 20px;
        height: 20px;
    }

    &:hover {
        color: rgba(255, 255, 255, 0.8);
        background: rgba(255, 255, 255, 0.08);
    }

    @include mobileOnly {
        top: $s-l;
        right: $s-l;
    }
}

.content {
    display: flex;
    flex-direction: column;
    gap: 0;
    align-items: flex-start;
    text-align: left;
}

.headline {
    margin: 0;
    margin-bottom: $s-xl;
    font-family: aktiv-grotesk-extended, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;
    font-size: 28px;
    font-weight: 700;
    line-height: 1.2;
    color: $c-white;
    text-align: left;
    letter-spacing: -0.03em;

    @include mobileOnly {
        margin-bottom: $s-l;
        font-size: $s-xl;
    }
}

.description {
    @extend %p;

    margin: 0 0 32px 0;
    font-size: $s-m;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.7);
    text-align: left;

    @include mobileOnly {
        margin-bottom: $s-xl;
        font-size: 14px;
    }
}

.actions {
    display: flex;
    flex-direction: column;
    gap: 1px;
    align-items: center;
    width: 100%;
    margin-bottom: 32px;

    @include mobileOnly {
        flex-direction: row;
        flex-wrap: wrap;
        gap: $s-m;
        align-items: center;
        justify-content: center;
        margin-bottom: $s-xl;
    }
}

.primaryButton {
    width: 100%;
    max-width: 400px;
    padding: $s-l 36px;
    font-size: $s-m;
    text-transform: none;
    letter-spacing: normal;
    border-radius: 50px;

    @include mobileOnly {
        flex: 0 0 auto;
        width: auto;
        padding: $s-m 28px;
    }
}

.instructions {
    font-size: 14px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.6);

    p {
        margin: 0 0 $s-s 0;
    }

    strong {
        color: rgba(255, 255, 255, 0.8);
    }

    @include mobileOnly {
        font-size: 13px;
    }
}

.instructionsList {
    padding: 0;
    margin: 0;
    list-style: decimal inside;

    li {
        margin-bottom: $s-xs;
    }
}

.optionsButton {
    padding: 2px $s-xs;
    font-family: monospace;
    font-weight: bold;
    color: $c-white;
    background: $c-nevada-grey;
    border-radius: 4px;
}
</style>
